import React from 'react'
import styles from "../vendorprofile/myprofile.module.css"
import VendorProfileMenu from '../../Components/vendorprofilemenu/VendorProfileMenu'
import AllVenEnquiresTab from '../../Components/allVenEnquiresTab/AllVenEnquiresTab'
import Myprofile from '../../../CustomerDash/Pages/myprofile/Myprofile'

const AllVenEnquires = () => {
    return (
        <>
           
            <Myprofile>
                <AllVenEnquiresTab />
            </Myprofile>    
        </>
    )
}

export default AllVenEnquires